<template>
  <financial-list
    v-model="currentPage"
    :header-data="TABLE_HEADERS"
    :data="transactions"
    :disabled="loadingPage"
    :items-per-page="itemsPerPage"
    @page-changed="loadTransactionsList"
    :total="total"
    :no-items-message="translations.missing_transactions"/>
</template>

<script>
import translations from '@/translations';
import { formatDatetime, formatValue } from '@/helpers/finance';
import { parseResponseError } from '@/http/parsers/parse_response';
import FinancialList, { associateHeaderDataItem } from '@/components/Financial/FinancialList.vue';
import { cloneDeep } from 'lodash';
import service from '@/services/finance-service';

export default {
  components: {
    FinancialList,
  },
  name: 'FinanceListTransaction',
  created() {
    this.TABLE_HEADERS = [
      associateHeaderDataItem(this.translations.transaction_id, 'id'),
      associateHeaderDataItem(this.translations.transaction_date, 'transaction_date'),
      associateHeaderDataItem(this.translations.client_name, 'client_name'),
      associateHeaderDataItem(this.translations.account_uuid, 'account_uuid'),
      associateHeaderDataItem(this.translations.program_uuid, 'program_uuid'),
      associateHeaderDataItem(this.translations.program_id, 'patient_id'),
      associateHeaderDataItem(this.translations.patient_name, 'member_full_name'),
      associateHeaderDataItem(this.translations.unit, 'unit'),
      associateHeaderDataItem(this.translations.therapy, 'therapy_name'),
      associateHeaderDataItem(this.translations.transaction_type, 'transaction_type'),
      associateHeaderDataItem(this.translations.value, 'transaction_value'),
    ];
  },
  data() {
    return {
      translations: translations.finance.transactions,
      transactions: [],
      loadingPage: true,
      itemsPerPage: 10,
      currentPage: 1,
      total: 0,
      appliedFilters: {},
    };
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    applyFilters(filters, page = 1) {
      this.currentPage = page;
      this.appliedFilters = cloneDeep(filters);

      this.loadTransactionsList();
    },
    async loadTransactionsList() {
      this.loadingPage = true;

      const searchFilters = {
        ...this.appliedFilters,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        order_by: 'id',
        order_descending: true,
        has_problematic_block_flags: false,
      };

      let apiTransactions;
      try {
        const { data: response } = await service.getTransactions(searchFilters);
        apiTransactions = response.data;
      } catch (err) {
        this.$noty.error(`${this.translations.errors.fetch_list_error}: ${parseResponseError(err)}`);
      }

      if (!apiTransactions) {
        this.total = 0;
        this.transactions = [];
      } else {
        this.total = apiTransactions.total;
        this.transactions = apiTransactions.transactions;
      }

      this.transactions.forEach(transaction => {
        transaction.transaction_date = formatDatetime(transaction.event_date);
        transaction.transaction_value = formatValue(transaction.transaction_value);
      });
      this.loadingPage = false;
    },
  },
};
</script>
